import { CURRENCY } from "../../../../components/Constants";
import {
  ErrorMessage,
  Field,
  FormikErrors,
  FormikHelpers,
  FormikValues,
} from "formik";
import ReactSelect from "react-select";
import {
  handleSalesInvoiceCalculation,
  n,
} from "../helpers/SalesInvoiceHelperFunction";
import { ContainerSize } from "../../../../components/Enums";
import { useCallback } from "react";
import { salesInvoiceProductValues } from "../helpers/SalesInvoiceHelper";
interface ProductFieldsProps {
  item: any;
  index: number;
  productList: any;
  unitList: any;
  packingType: any;
  values: FormikValues;
  remove: (index: number) => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void | FormikErrors<FormikValues>>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setAddUnitModalStatus: (show: boolean) => void;
  setAddPackingTypeModalStatus: (show: boolean) => void;
  setAddProductModalStatus: (show: boolean) => void;
  handleProductChange: (
    index: any,
    productId: any,
    values: any,
    setFieldValue: any,
  ) => void;
  remainingQtyList: { [product_id: string]: number };
  setFieldError: FormikHelpers<any>["setFieldError"];
  errors: any;
  permissions: any;
}

const ProductFields: React.FC<ProductFieldsProps> = ({
  item,
  index,
  remove,
  productList,
  unitList,
  packingType,
  values,
  setFieldValue,
  handleChange,
  setAddUnitModalStatus,
  setAddPackingTypeModalStatus,
  setAddProductModalStatus,
  handleProductChange,
  remainingQtyList,
  setFieldError,
  errors,
  permissions,
}) => {
  const currentProductValue = values.sales_invoice_products[index];
  const updateValue = useCallback(
    (key: string, val: any): number | "" => {
      const formatted = val && val > 0 ? +n(val).toFixed(3) : "";
      setFieldValue(key, formatted);
      return formatted;
    },
    [setFieldValue],
  );

  // Set gross weight = net_weight + packing_type_weight & total_gross_weight = gross_weight * no_of_bags
  const changeGrossWeight = () => {
    let packing_gross_weight;
    let total_gross_weight;

    // get packing weight from packing type list
    const packingWeight = packingType.find(
      (packingType: any) =>
        packingType.id === currentProductValue.packing_type_id,
    )?.weight;

    if (
      currentProductValue.packing_net_weight &&
      currentProductValue.packing_type_id
    ) {
      packing_gross_weight =
        n(currentProductValue.packing_net_weight) + n(packingWeight);
      total_gross_weight =
        n(currentProductValue.no_of_bags) * n(packing_gross_weight);
    } else {
      packing_gross_weight = "";
      total_gross_weight = "";
    }

    currentProductValue.packing_gross_weight = updateValue(
      `sales_invoice_products[${index}].packing_gross_weight`,
      packing_gross_weight,
    );

    currentProductValue.total_gross_weight = updateValue(
      `sales_invoice_products[${index}].total_gross_weight`,
      total_gross_weight,
    );
  };

  // Set containers no_of_bags, total_net_weight & total_gross_weight values same as product's values
  const setContainerNetAndGrossWeightValues = () => {
    const updatedContainers = values.container.map((c: any) =>
      c.product_id === currentProductValue.product_id
        ? {
            ...c,
            total_net_weight:
              n(c.no_of_bags) * n(currentProductValue.packing_net_weight),
            total_gross_weight:
              n(c.no_of_bags) * n(currentProductValue.packing_gross_weight),
          }
        : c,
    );

    setFieldValue("container", updatedContainers);
  };

  // Remove container details when product removes
  const removeContainers = (
    removedProductId: string,
    removedContractId: string,
  ) => {
    const updatedContainers = values.container.filter(
      (container: any) =>
        !(
          container.product_id === removedProductId &&
          container.sales_contract_id === removedContractId
        ),
    );

    setFieldValue("container", updatedContainers);
  };

  return (
    <div
      className="row m-0 mb-3 gy-1"
      style={{
        border: "1px solid #d1d0d4",
        borderRadius: "0.375rem",
        padding: "10px 5px 20px 5px",
      }}
    >
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <div className="d-flex justify-content-between">
          <div>
            <label
              htmlFor={`sales_invoice_products[${index}].product_id`}
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Product: <span className="text-danger">*</span>
            </label>
          </div>
          {permissions.includes("create-product") && (
            <div>
              <button
                title="Add Product"
                className="btn btn-sm btn-primary waves-effect waves-light p-0"
                type="button"
                onClick={() => setAddProductModalStatus(true)}
              >
                <span>
                  <i className="ti ti-plus my-card-icon-button"></i>
                </span>
              </button>
            </div>
          )}
        </div>
        <Field
          id={`sales_invoice_products[${index}].product_id`}
          name={`sales_invoice_products[${index}].product_id`}
        >
          {({ field, form }: any) => {
            const options = productList.map((option: any) => ({
              ...option,
              label: `${option.products?.name} - ${option.contract_no}`,
              value: `${option.product_id}_${option.contract_id}`,
            }));

            const selectedOption = options.find(
              (option: any) =>
                option.value ===
                `${currentProductValue.product_id}_${currentProductValue.sales_contract_id}`,
            );
            // const selectedOption = productList.find(
            //   (option: any) => option.id === field.value,
            // );
            // const formatOptionLabel = (option: any, { context }: any) => {
            //   if (context === "value") {
            //     return option.name;
            //   } else {
            //     return (
            //       <div>
            //         <label className="form-label">{option.name}</label> -
            //         <label className="form-label">{option.variety}</label>
            //         <br />
            //         <span className="form-label">{option.description}</span>
            //       </div>
            //     );
            //   }
            // };

            const selectedProductContracts = values.sales_invoice_products
              .filter((_: any, i: number) => i !== index)
              .map((p: any) => `${p.product_id}_${p.sales_contract_id}`);

            const filteredOptions = productList
              .filter((option: any) => {
                const optionKey = `${option.product_id}_${option.contract_id}`;
                const currentKey = `${currentProductValue.product_id}_${currentProductValue.sales_contract_id}`;

                return (
                  option.products?.name &&
                  option.contract_no &&
                  (!selectedProductContracts.includes(optionKey) ||
                    optionKey === currentKey)
                );
              })
              .map((option: any) => ({
                ...option,
                label: `${option.products.name} - ${option.contract_no}`,
                value: `${option.product_id}_${option.contract_id}`,
              }));
            return (
              <>
                <ReactSelect
                  {...field}
                  classNamePrefix="react-select"
                  placeholder="Select Product"
                  options={filteredOptions}
                  getOptionLabel={(option: any) => option.label}
                  getOptionValue={(option: any) => option.value}
                  onChange={(selectedOption: any) => {
                    removeContainers(
                      currentProductValue.product_id,
                      currentProductValue.sales_contract_id,
                    );

                    // CLEAR CASE
                    if (!selectedOption) {
                      setFieldValue(`sales_invoice_products[${index}]`, {
                        ...salesInvoiceProductValues,
                      });

                      handleSalesInvoiceCalculation(
                        "both",
                        values,
                        setFieldValue,
                      );
                      return;
                    }

                    const [productId, contractId] =
                      selectedOption.value.split("_");

                    setFieldValue(
                      `sales_invoice_products[${index}].product_id`,
                      productId,
                    );

                    setFieldValue(
                      `sales_invoice_products[${index}].sales_contract_id`,
                      contractId,
                    );

                    handleProductChange(
                      index,
                      selectedOption.value,
                      values,
                      setFieldValue,
                    );
                  }}
                  value={selectedOption || null}
                  isClearable
                  isSearchable
                />
                {form.errors.sales_invoice_products &&
                  form.errors.sales_invoice_products[index] &&
                  form.errors.sales_invoice_products[index].product_id && (
                    <div className="text-danger">
                      {form.errors.sales_invoice_products[index].product_id}
                    </div>
                  )}
              </>
            );
          }}
        </Field>
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].price`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Price ({CURRENCY.USD.SYMBOL}):
          <span className="text-danger">*</span>
        </label>
        <Field
          id={`sales_invoice_products[${index}].price`}
          name={`sales_invoice_products[${index}].price`}
          type="number"
          className="form-control"
          placeholder="Enter Price"
          value={currentProductValue.price || ""}
          onChange={(e: any) => {
            const price = updateValue(e.target.name, e.target.value);
            currentProductValue.total_amount = updateValue(
              `sales_invoice_products[${index}].total_amount`,
              e.target.value * n(price),
            );
            handleSalesInvoiceCalculation(
              "total_amount",
              values,
              setFieldValue,
            );
          }}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].price`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].quantity`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Quantity (MTS): <span className="text-danger">*</span>
        </label>
        <Field
          id={`sales_invoice_products[${index}].quantity`}
          name={`sales_invoice_products[${index}].quantity`}
          type="number"
          className="form-control"
          placeholder="Enter Quantity"
          value={currentProductValue.quantity || ""}
          onChange={(e: any) => {
            const key = `${currentProductValue.product_id}_${currentProductValue.sales_contract_id}`;
            if (Number(e.target.value) > remainingQtyList[key]) {
              setFieldError(
                e.target.name,
                `You can use a maximum ${remainingQtyList[key]} units for this product as per the sales contract.`,
              );
            } else if (Number(e.target.value) <= remainingQtyList[key]) {
              currentProductValue.quantity = updateValue(
                e.target.name,
                e.target.value,
              );
              currentProductValue.total_amount = updateValue(
                `sales_invoice_products[${index}].total_amount`,
                currentProductValue.quantity * currentProductValue.price,
              );

              handleSalesInvoiceCalculation(
                "total_amount",
                values,
                setFieldValue,
              );
            }
          }}
        />

        {errors.sales_invoice_products &&
          errors.sales_invoice_products[index] &&
          errors.sales_invoice_products[index].quantity && (
            <div className="text-danger">
              {errors.sales_invoice_products[index].quantity}
            </div>
          )}
        {/* <ErrorMessage
          name={`sales_invoice_products[${index}].quantity`}
          className="text-danger"
          component="div"
        /> */}
      </div>

      {/* Quantity unit always in MTS */}
      {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <div className="d-flex justify-content-between">
          <div>
            <label
              htmlFor={`sales_invoice_products[${index}].quantity_unit_id`}
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Quantity Unit:
            </label>
          </div>
          <div>
            <button
              title="Add Unit"
              className="btn btn-sm btn-primary waves-effect waves-light p-0"
              type="button"
              onClick={() => setAddUnitModalStatus(true)}
            >
              <span>
                <i className="ti ti-plus my-card-icon-button"></i>
              </span>
            </button>
          </div>
        </div>
        <select
          id={`sales_invoice_products[${index}].quantity_unit_id`}
          name={`sales_invoice_products[${index}].quantity_unit_id`}
          className="form-select"
          // value={values.quantity_unit_id}
          value={
            currentProductValue.quantity_unit_id || undefined
          }
          onChange={handleChange}
        >
          <option defaultChecked value={""}>
            Select Quantity Unit
          </option>
          {unitList.map((unit: any) => (
            <option key={unit.id} value={unit.id}>
              {unit.name}
            </option>
          ))}
        </select>
        <ErrorMessage
          name={`sales_invoice_products[${index}].quantity_unit_id`}
          className="text-danger"
          component="div"
        />
      </div> */}

      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label className="form-label" style={{ fontSize: "0.9375rem" }}>
          Total Amount ({CURRENCY.USD.SYMBOL}):{" "}
          <span className="text-danger">*</span>
        </label>
        <Field
          id={`sales_invoice_products[${index}].total_amount`}
          name={`sales_invoice_products[${index}].total_amount`}
          type="number"
          className="form-control"
          placeholder="0"
          onChange={(e: any) => {
            currentProductValue.total_amount = updateValue(
              e.target.name,
              e.target.value,
            );
            handleSalesInvoiceCalculation(
              "total_amount",
              values,
              setFieldValue,
            );
          }}
          value={currentProductValue.total_amount}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].total_amount`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].no_of_containers`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          No. of Containers:
        </label>
        <Field
          name={`sales_invoice_products[${index}].no_of_containers`}
          type="text"
          className="form-control"
          placeholder="Enter No of containers"
          onChange={handleChange}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].no_of_containers`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].container_load`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Container Size:
        </label>
        <select
          id={`sales_invoice_products[${index}].container_load`}
          name={`sales_invoice_products[${index}].container_load`}
          className="form-control"
          value={currentProductValue.container_load || ""}
          onChange={handleChange}
        >
          <option defaultChecked value={""}>
            Select Container Size{""}
          </option>
          <option value={ContainerSize.TWENTY}>{ContainerSize.TWENTY}</option>
          <option value={ContainerSize.FORTY}>{ContainerSize.FORTY}</option>
        </select>
        <ErrorMessage
          name={`sales_invoice_products[${index}].container_load`}
          component="div"
          className="text-danger"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <div className="d-flex justify-content-between">
          <div>
            <label
              htmlFor={`sales_invoice_products[${index}].packing_type_id`}
              className="form-label"
              style={{ fontSize: "0.9375rem" }}
            >
              Packing Type:
            </label>
          </div>
          {permissions.includes("create-packing-type") && (
            <div>
              <button
                title="Add Packing Type"
                className="btn btn-sm btn-primary waves-effect waves-light p-0"
                type="button"
                onClick={() => setAddPackingTypeModalStatus(true)}
              >
                <span>
                  <i className="ti ti-plus my-card-icon-button"></i>
                </span>
              </button>
            </div>
          )}
        </div>
        <select
          id={`sales_invoice_products[${index}].packing_type_id`}
          name={`sales_invoice_products[${index}].packing_type_id`}
          className="form-select"
          value={currentProductValue?.packing_type_id}
          onChange={(e) => {
            setFieldValue(e.target.name, e.target.value);
            currentProductValue.packing_type_id = e.target.value;
            // Set gross weight = packing_type_weight + net_weight & set total_gross_weight
            changeGrossWeight();
            // Set total_gross_weight value in Grand total section
            handleSalesInvoiceCalculation(
              "total_gross_weight",
              values,
              setFieldValue,
            );
            // Set changed total_gross_weight value in container where product_id = current product_id
            setContainerNetAndGrossWeightValues();
          }}
        >
          <option defaultChecked value={""}>
            Select Packing Types
          </option>
          {packingType.map((packing: any) => (
            <option key={packing.id} value={packing.id}>
              {packing.name}
            </option>
          ))}
        </select>
        <ErrorMessage
          name={`sales_invoice_products[${index}].packing_type_id`}
          className="text-danger"
          component="div"
        />
      </div>

      {/* Packing unit always in KGS */}
      {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].packing_unit_id`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Packing Unit:
        </label>
        <select
          id={`sales_invoice_products[${index}].packing_unit_id`}
          name={`sales_invoice_products[${index}].packing_unit_id`}
          className="form-select"
          value={
            currentProductValue.packing_unit_id || undefined
          }
          onChange={handleChange}
        >
          <option defaultChecked value={""}>
            Select Packing Unit
          </option>
          {unitList.map((unit: any) => (
            <option key={unit.id} value={unit.id}>
              {unit.name}
            </option>
          ))}
        </select>
        <ErrorMessage
          name={`sales_invoice_products[${index}].packing_unit_id`}
          className="text-danger"
          component="div"
        />
      </div> */}

      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].no_of_bags`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          No. of Bags:
        </label>
        <Field
          id={`sales_invoice_products[${index}].no_of_bags`}
          name={`sales_invoice_products[${index}].no_of_bags`}
          type="number"
          className="form-control"
          placeholder="Enter No. of bags"
          value={currentProductValue.no_of_bags || ""}
          onChange={(e: any) => {
            currentProductValue.no_of_bags = updateValue(
              e.target.name,
              n(e.target.value),
            );
            currentProductValue.total_net_weight = updateValue(
              `sales_invoice_products[${index}].total_net_weight`,
              n(e.target.value) * n(currentProductValue.packing_net_weight),
            );
            currentProductValue.total_gross_weight = updateValue(
              `sales_invoice_products[${index}].total_gross_weight`,
              n(e.target.value) * n(currentProductValue.packing_gross_weight),
            );

            handleSalesInvoiceCalculation(
              "total_no_of_bags",
              values,
              setFieldValue,
            );
            setContainerNetAndGrossWeightValues();
          }}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].no_of_bags`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].packing_net_weight`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Packing Net Weight (KGS):
        </label>
        <Field
          id={`sales_invoice_products[${index}].packing_net_weight`}
          name={`sales_invoice_products[${index}].packing_net_weight`}
          type="number"
          className="form-control"
          placeholder="Enter Packing Net Weight"
          value={currentProductValue.packing_net_weight || ""}
          onChange={(e: any) => {
            currentProductValue.packing_net_weight = updateValue(
              e.target.name,
              e.target.value,
            );
            currentProductValue.total_net_weight = updateValue(
              `sales_invoice_products[${index}].total_net_weight`,
              n(e.target.value) * n(currentProductValue.no_of_bags),
            );

            changeGrossWeight();
            // Set total_net_weight & total_gross_weight
            handleSalesInvoiceCalculation(
              "total_no_of_bags",
              values,
              setFieldValue,
            );
            setContainerNetAndGrossWeightValues();
          }}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].packing_net_weight`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label className="form-label" style={{ fontSize: "0.9375rem" }}>
          Total Packing Net Weight (KGS):
        </label>
        <Field
          name={`sales_invoice_products[${index}].total_net_weight`}
          type="number"
          className="form-control"
          value={currentProductValue.total_net_weight || ""}
          onChange={(e: any) => {
            currentProductValue.total_net_weight = updateValue(
              e.target.name,
              e.target.value,
            );
            handleSalesInvoiceCalculation(
              "total_net_weight",
              values,
              setFieldValue,
            );
          }}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].total_net_weight`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label
          htmlFor={`sales_invoice_products[${index}].packing_gross_weight`}
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Packing Gross Weight (KGS):
        </label>
        <Field
          id={`sales_invoice_products[${index}].packing_gross_weight`}
          name={`sales_invoice_products[${index}].packing_gross_weight`}
          type="number"
          className="form-control"
          placeholder="Enter Packing Gross Weight"
          value={currentProductValue.packing_gross_weight || ""}
          onChange={(e: any) => {
            currentProductValue.packing_gross_weight = updateValue(
              e.target.name,
              e.target.value,
            );
            currentProductValue.total_gross_weight = updateValue(
              `sales_invoice_products[${index}].total_gross_weight`,
              n(e.target.value) * n(currentProductValue.no_of_bags),
            );
            handleSalesInvoiceCalculation(
              "total_gross_weight",
              values,
              setFieldValue,
            );
            setContainerNetAndGrossWeightValues();
          }}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].packing_gross_weight`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
        <label className="form-label" style={{ fontSize: "0.9375rem" }}>
          Total Packing Gross Weight (KGS):
        </label>
        <Field
          name={`sales_invoice_products[${index}].total_gross_weight`}
          className="form-control"
          value={currentProductValue.total_gross_weight || ""}
          onChange={(e: any) => {
            currentProductValue.total_gross_weight = updateValue(
              e.target.name,
              e.target.value,
            );
            handleSalesInvoiceCalculation(
              "total_gross_weight",
              values,
              setFieldValue,
            );
          }}
        />
        <ErrorMessage
          name={`sales_invoice_products[${index}].total_gross_weight`}
          className="text-danger"
          component="div"
        />
      </div>
      <div className="col-12 col-sm-6 col-lg-2 d-flex align-items-end">
        <button
          type="button"
          className="btn btn-danger mt-3"
          onClick={() => {
            removeContainers(
              currentProductValue.product_id,
              currentProductValue.sales_contract_id,
            );
            remove(index);
            const updatedProducts = values.sales_invoice_products
              .filter((_: any, indexKey: number) => indexKey !== index)
              .filter(Boolean);
            values.sales_invoice_products = updatedProducts;
            setFieldValue("sales_invoice_products", updatedProducts);

            handleSalesInvoiceCalculation("both", values, setFieldValue);
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default ProductFields;
